import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-center",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "pl-2 date-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      variant: "text",
      color: "primary",
      large: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            start: "",
            large: "",
            color: "primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-calendar", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formattedDate), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.subtract,
        variant: "text",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.previousMonth')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.add,
        variant: "text",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.nextMonth')) + " ", 1),
          _createVNode(_component_v_icon, { end: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}